import { Injectable } from "@angular/core";
import { Storage } from "@ionic/storage";
import { Platform } from "@ionic/angular";

@Injectable({
  providedIn: "root",
})
export class SessionService {
  constructor(private storage: Storage, private platfom: Platform) {}

  setSession(data: any): Promise<any> {
    const stringData = JSON.stringify(data);
    return this.storage.set("_session_data", stringData);
  }

  getSession(): Promise<any> {
    return this.storage.get("_session_data");
  }

  emptySession(): Promise<any> {
    return this.storage.remove("_session_data");
  }
}
